import { useEffect, useState } from 'react';
import { BlockStack, Button, ChoiceList, Modal, SkeletonBodyText, Text } from '@shopify/polaris';
import { withRouter } from 'react-router';
import Language from "../../i18n/Language";
import "./index.scss";
import { store } from '../../redux/store';
import { reqGetNewUserPricingPlanList, reqGetSubscription } from '../../api';
import { computeBestDiscount } from '../../utils/planRateCalc';
import { isAnnualDefaultCountry } from '../../utils/constants';

const t = Language;

const UserTrialDicountModal = (props) => {
    const {
        openState,
        operaType,
        isComboUser,
        language,
        isModal,

        cioPlanDataSet,
        handleOpenCwComboModal,
        handleCloseTrialModal,
        getPageDataRedux,
        toggleToast,
        handleModeJump,
        sendDataToMain,

    } = props;

    const [lang, setLang] = useState("en");   // 语言
    const [open, setOpen] = useState(false);  // 弹窗是否打开
    // const [userlevel, setUserlevel] = useState(1);  // 用户等级
    const [planSel, setPlanSel] = useState('Annual');  // 年/月版本
    const [planLoading, setPlanLoading] = useState(true);  // 价格方案加载状态
    const [trialDays, setTrialDays] = useState(0);  // 试用天数
    const [pubTrialDays, setPubTrialDays] = useState(0);  // 公共试用天数
    const [paidLoading, setPaidLoading] = useState(false);  // 支付加载状态
    const [prePlanInfo, setPrePlanInfo] = useState({
        pre_month: {},
        pre_year: {},
    });  // 预选方案
    const [planResData, setPlanResData] = useState({});  // 价格方案数据
    const [jumpLoading, setJumpLoading] = useState(false);  // 跳转加载状态
    const preList = [
        t("500+ AI credits for AI blog generation"),
        t("Audit unlimited pages to fix SEO issues"),
        t("Boost site speed with Turbo Optimization")
    ];
    const steps = [
        {
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="12" fill="var(--color-primary-bg)" />
                <path d="M14.4 6V7.8" stroke="var(--color-primary)" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M9.60001 6V7.8" stroke="var(--color-primary)" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M6.60001 9.29941C6.60001 7.97393 7.67452 6.89941 9.00001 6.89941H15C16.3255 6.89941 17.4 7.97393 17.4 9.29941V15.5994C17.4 16.9249 16.3255 17.9994 15 17.9994H9.00001C7.67453 17.9994 6.60001 16.9249 6.60001 15.5994V9.29941Z" stroke="var(--color-primary)" strokeWidth="1.2" />
                <path d="M6.60001 10.2002H17.4" stroke="var(--color-primary)" strokeWidth="1.2" strokeLinecap="round" />
            </svg>,
            title: t("Choose your plan"),
            desc: t("Choose Annual or Monthly."),
        },
        {
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="12" fill="var(--color-primary-bg)" />
                <path d="M13.4319 8.29829L15.7014 10.5678M6.60001 17.3996L8.80367 16.9801C9.27092 16.8912 9.70062 16.6638 10.0369 16.3274L16.9102 9.45413C17.5633 8.80112 17.5633 7.74238 16.9102 7.08937C16.2572 6.43636 15.1985 6.43636 14.5455 7.08937L7.67218 13.9627C7.33586 14.299 7.10845 14.7287 7.0195 15.1959L6.60001 17.3996Z" stroke="var(--color-primary)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            title: t("Start Trial — $0 today"),
            desc: t("{{v1}}-day free trial · Cancel anytime", trialDays),
        },
        {
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="12" fill="var(--color-primary-bg)" />
                <path d="M8.39994 9.59961L10.6687 11.1121C11.4748 11.6495 12.5251 11.6495 13.3312 11.1121L15.5999 9.59961M8.39994 17.3996H15.5999C16.9254 17.3996 17.9999 16.3251 17.9999 14.9996V8.99961C17.9999 7.67413 16.9254 6.59961 15.5999 6.59961H8.39994C7.07446 6.59961 5.99994 7.67413 5.99994 8.99961V14.9996C5.99994 16.3251 7.07446 17.3996 8.39994 17.3996Z" stroke="var(--color-primary)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            title: t("Reminder email - {{v1}}", getFutureDate(trialDays - 2, lang)),
            desc: t("We'll email you {{v1}} days before your trial ends.", 2),
        }
    ];

    // 检查图标
    const checkIcon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 9L7.5 12L13.5 6" stroke="var(--color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

    // 选择年/月版本
    const handlePlanChange = (value) => {
        let sel = value[0];
        setTrialDays(sel === 'Annual' ? prePlanInfo.pre_year?.trial_days : prePlanInfo.pre_month?.trial_days);
        setPlanSel(sel);
    }

    // 设置弹窗样式
    const changePopoverCss = (isSet = true) => {
        const STYLE_ID = 'trial-modal-size-style';
        let styleEl = document.getElementById(STYLE_ID); // 识别唯一id
        if (isSet) {
            if (!styleEl) {
                styleEl = document.createElement('style');
                styleEl.id = STYLE_ID;
                styleEl.textContent = `
                    .Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge {
                        max-width: 840px;
                    }
                `;
                document.head.appendChild(styleEl);
            }
        } else {
            setTimeout(() => {
                if (styleEl) {
                    styleEl.remove();
                }
            }, 500)
        }
    }

    // 请求价格数据
    const getPricingPlan = async () => {
        let _actData = store.getState().public.ActMealData;
        let _page = store.getState().page;
        let cache = _page.pageInit?.pricingPlan;
        if (Object.keys(_actData).length > 0) {
            setPlanLoading(true);
            let params = {
                activity_id: _actData.activity_id,
            };
            let res = cache || await reqGetNewUserPricingPlanList(params);
            if (res.ack === 1) {
                getPageDataRedux(res, 'pricingPlan'); // 设置价格缓存数据
                setPlanLoading(false);
                let planInfo = {
                    pre_month: computeBestDiscount(res.data, res.data.meal_list.month[1]),
                    pre_year: computeBestDiscount(res.data, res.data.meal_list.year[1]),
                }
                setTrialDays(planInfo.pre_year?.trial_days || planInfo.pre_month?.trial_days || res.data.trial_days);
                // 国家判断：仅白名单国家默认Annual，其他国家默认Monthly
                let _country = store.getState().public.publicInit?.shop_data?.country;
                let _isAnnualDefaultCountry = isAnnualDefaultCountry(_country);
                // 可选项判断（与 trialSelectArr 保持一致）
                let _hasBoth = (planInfo.pre_month?.trial_days > 0 && planInfo.pre_year?.trial_days > 0) || res.data.trial_days > 0;
                let _hasYearOnly = planInfo.pre_year?.trial_days > 0;
                let _defaultSel;
                if (_hasBoth) {
                    // 年月版本都可选时，按国家白名单决定默认值
                    _defaultSel = _isAnnualDefaultCountry ? 'Annual' : 'Monthly';
                } else {
                    // 只有单一版本可选时，选中实际可用的版本
                    _defaultSel = _hasYearOnly ? 'Annual' : 'Monthly';
                }
                setPlanSel(_defaultSel);
                setPubTrialDays(res.data.trial_days);
                setPrePlanInfo(planInfo);
                setPlanResData(res.data);
                // setUserlevel(res.data.level);

                // posthog 弹窗埋点
                props.cwreportCustomBehavior('guide_entry_exposure', {
                    source_type: "free_trial",
                    planRes: res.data,
                    planInfo,
                    selData: _defaultSel === 'Annual' ? planInfo.pre_year : planInfo.pre_month,
                });
            } else {
                toggleToast(res.msg, true);
            }
        } else {
            setTimeout(() => {
                getPricingPlan();
            }, 500)
        }
    }

    // 跳转价格页
    const jumpOperaPage = () => {
        if (operaType === 1) {
            setJumpLoading(true);
            handleModeJump && handleModeJump();
            setTimeout(() => {
                setJumpLoading(false);
            }, 3000)
        } else {
            const isShopify = window.shopify;
            if (isShopify && window.opener) {
                sendDataToMain({ url: "/plan", _state: null, _query: null }, 'url');
            } else {
                let paths = {
                    // pathname: operaType === 1 ? "/dashboard" : "/plan",
                    pathname: "/plan",
                    query: null,
                }
                props.history.push(paths);
            }
        }
    }

    // 关闭弹窗
    const handleCloseModal = () => {
        setOpen(false);
        handleCloseTrialModal();
        if (operaType === 1) {
            jumpOperaPage();
        }
    }

    // 跳转支付
    const handleTryFree = async () => {
        setPaidLoading(true);
        let selData = planSel === 'Monthly' ? prePlanInfo.pre_month : prePlanInfo.pre_year;
        // 判断是否组合付费用户 
        if (isComboUser) {
            setPaidLoading(false);
            handleOpenCwComboModal('showTrialModalState');  // 打开提示弹窗
        } else {

            // 获取套餐来源
            let _params = {
                source_type: "free_trial",
                planRes: planResData,
                planInfo: prePlanInfo,
                selData,
            }
            let _t = props.handleGetPlanSource('enter_checkout', _params);

            let params = {
                ppid: selData.id,
                price: Number(selData.price),
                is_verify: 0,

                source_type: _t.source_type,
                source_position: _t.source_position,
                plan_type: _t.plan_type,
                plan_version: _t.plan_version,
                discount: _t.discount,
                paid_type: _t.paid_type,
            }
            // 活动折扣
            if (selData.rate) {
                params.activity_id = selData.activity_id;
            }
            // 优惠券折扣
            if (selData.code) {
                params.coupon_code = selData.code;
            }
            // cio埋点
            let yPrice = (selData.price / 12).toFixed(2);
            cioPlanDataSet(([2, 4].includes(selData.id) ? 'monthly' : [8, 9].includes(selData.id) ? 'annually' : ''), ([2, 8].includes(selData.id) ? 'Pro Plan' : [4, 9].includes(selData.id) ? 'Pre Plan' : ''), 0, ([8, 9].includes(selData.id) ? yPrice : selData.price));
            // posthog 支付埋点
            props.cwreportCustomBehavior('enter_checkout', _params);
            // 请求
            const res = await reqGetSubscription(params);
            if (res.ack === 1) {
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        handleJumpSubUrl(j_url);
                    }
                }
            } else {
                toggleToast(res.msg, true);
                setPaidLoading(false);
            }
        }
    }

    // 监听支付跳转
    const handleJumpSubUrl = (j_url) => {
        if (window.top) {
            window.top.location.href = j_url;
        } else {
            setTimeout(() => {
                handleJumpSubUrl(j_url);
            }, 5000)
        }
    }

    // 监听弹窗打开
    useEffect(() => {
        let _status = Boolean(openState);
        setOpen(_status);
        changePopoverCss(_status);
        if (_status || !isModal) {
            getPricingPlan();
        }
    }, [openState, isModal]);

    // 设置语言
    useEffect(() => {
        setLang(language);
    }, [language]);

    useEffect(() => {
        return () => {
            changePopoverCss(false);
        }
    }, []);

    // logo
    const s_logo = <svg width="250" height="251" viewBox="0 0 250 251" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M158.193 0C175.772 4.94893e-05 207.33 6.04147 224.496 23.3281C241.473 40.4237 250.263 64.5118 249.993 90.3936C249.875 101.735 247.349 113.421 244.134 125.014C236.872 98.8299 222.022 70.9396 199.619 48.3799C177.219 25.8229 150.996 9.24083 124.998 1.92676C77.4541 13.5169 41.6709 64.5399 41.6709 125.014C41.671 185.49 77.457 236.512 125.004 248.1C151.001 240.783 177.222 221.247 199.621 198.692C222.025 176.132 236.877 151.2 244.139 125.016C247.418 136.84 249.942 148.475 249.998 159.635C250.123 184.386 241.329 206.798 224.5 223.744C206.03 242.342 173.819 250.029 152.333 250.029C150.38 250.029 134.761 250.028 124.993 248.106C118.268 249.742 111.919 250.026 104.79 250.026C47.2546 250.026 0.000168036 194.056 0 125.014C-1.93416e-06 55.971 47.2545 0.000197635 104.79 0C111.922 2.55081e-07 118.274 0.283346 125.002 1.9209C136.724 0.0838301 156.241 0 158.193 0Z" fill="url(#paint0_linear_7596_15581)" />
        <defs>
            <linearGradient id="paint0_linear_7596_15581" x1="207.104" y1="16.421" x2="76.407" y2="250" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="white" stopOpacity="0.3" />
            </linearGradient>
        </defs>
    </svg>

    // 年/月版本 试用数组
    const trialSelectArr = ((prePlanInfo.pre_month?.trial_days > 0 && prePlanInfo.pre_year?.trial_days > 0) || pubTrialDays > 0) ? [
        {
            label: <div className='flex_layout'>
                <span>{t("Annual")}</span>
                <span className='best_value'>{t("Best value - save {{v1}}/year", "$" + prePlanInfo.pre_year?.save_price)}</span>
            </div>,
            value: 'Annual',
            helpText: t("{{v1}}/mo (Billed yearly after trial)", "$" + Number(prePlanInfo.pre_year?.price / 12).toFixed(2)),
        },
        {
            label: t("Monthly"),
            value: 'Monthly',
            helpText: t("{{v1}}/first mo", "$" + Number(prePlanInfo.pre_month?.price).toFixed(2)),
        },
    ] : prePlanInfo.pre_month?.trial_days > 0 ? [
        {
            label: t("Monthly"),
            value: 'Monthly',
            helpText: t("{{v1}}/first mo", "$" + Number(prePlanInfo.pre_month?.price).toFixed(2)),
        }
    ] : prePlanInfo.pre_year?.trial_days > 0 ? [
        {
            label: <div className='flex_layout'>
                <span>{t("Annual")}</span>
                <span className='best_value'>{t("Best value - save {{v1}}/year", "$" + prePlanInfo.pre_year?.save_price)}</span>
            </div>,
            value: 'Annual',
            helpText: t("{{v1}}/mo (Billed yearly after trial)", "$" + Number(prePlanInfo.pre_year?.price / 12).toFixed(2)),
        }
    ] : [];

    // 主内容
    const mainInfo = <div className='user_trial_dicount_modal_content'>
        <div className="modal-container">
            {/* Left Section */}
            <div className="left-section">
                <BlockStack gap={200}>
                    <Text as="p" variant="headingLg">
                        {t("Try Premium free for {{v1}} days", trialDays)}
                    </Text>
                    <Text variant="bodyMd" as="p" tone="subdued">
                        {t("Boost your website traffic by 4.2x with Premium")}
                    </Text>
                </BlockStack>

                {/* Features list */}
                <div className="features-section">
                    <ul className="features-list">
                        {
                            preList.map((item, index) => {
                                return <li className="feature-item" key={index}>
                                    <span className="check-icon">{checkIcon}</span>
                                    <span>{t(item)}</span>
                                </li>
                            })
                        }
                    </ul>
                </div>

                {/* 年/月版本 */}
                <div className="version-section">
                    {
                        planLoading ? <BlockStack gap={400}>
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                        </BlockStack> :
                            <ChoiceList
                                choices={trialSelectArr}
                                selected={planSel}
                                onChange={handlePlanChange}
                            />
                    }
                </div>

                {/* 版本价格 */}
                <div className="version-price">
                    <div className='row_line_05'></div>
                    {
                        planLoading ? <BlockStack gap={400}>
                            <SkeletonBodyText lines={2} />
                        </BlockStack> : <>
                            <div className='vp_end_time'>
                                <span className='Every_Card_Desc'>{`${t("Due after trial")} · ${trialDays > 0 ? getFutureDate(trialDays, lang) : "-"}`}</span>
                                <span className='Every_Card_Desc'>
                                    {planSel === 'Annual' ? `$${prePlanInfo.pre_year?.price}` : `$${prePlanInfo.pre_month?.price}`}
                                </span>
                            </div>
                            <div className='vp_today'>
                                <span>{t("Due today")}</span>
                                <span>{t("$0")}</span>
                            </div>
                        </>
                    }
                </div>

                {/* Action buttons */}
                <div className="action-buttons">
                    <Button variant="primary" size="large" loading={planLoading || paidLoading} onClick={handleTryFree}>
                        {t("Try Free For {{v1}} Days", trialDays)}
                    </Button>
                    <Button size="large" onClick={jumpOperaPage} loading={jumpLoading}>
                        {
                            operaType === 1 ? t("No Thanks") : t("View All Plans")
                        }
                    </Button>
                </div>
            </div>

            {/* Right Section */}
            <div className="right-section">
                <span className='logo_bg'>{s_logo}</span>
                <div className='free-trial-steps-container'>
                    <div className="free-trial-steps">
                        <div className='icon_line'></div>
                        {steps.map((item, idx) => (
                            <div key={idx} className="step">
                                <div className={`icon`}>{item.icon}</div>
                                <div className="text">
                                    <p className="title">{t(item.title)}</p>
                                    <p className="desc">{t(item.desc)}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='step_line'></div>
                    <div className='subscription_step free-trial-steps'>
                        <div className="step">
                            <div className={`icon`}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="var(--color-primary-bg)" />
                                    <path d="M15.3008 5.5C15.8507 5.5 16.3732 5.73805 16.7363 6.15169L18.6842 8.37109C19.2933 9.06494 19.3292 10.0968 18.7708 10.832L13.5215 17.7422C12.754 18.7524 11.246 18.7524 10.4785 17.7422L5.22917 10.832C4.67079 10.0968 4.70669 9.06494 5.31576 8.37109L7.26368 6.15169C7.62684 5.73805 8.1493 5.5 8.69922 5.5H15.3008ZM5.93815 10.0885C5.96287 10.1366 5.99185 10.183 6.02539 10.2272L11.1914 17.028L8.80795 10.0885H5.93815ZM12.8079 17.028L17.9746 10.2272C18.0082 10.183 18.0371 10.1366 18.0619 10.0885H15.1921L12.8079 17.028ZM12 16.3034L14.1348 10.0885H9.86524L12 16.3034ZM15.1751 9.08854H17.9792C17.9645 9.0689 17.9493 9.04927 17.9329 9.0306L15.985 6.81185C15.8102 6.61267 15.5606 6.5 15.3008 6.5H14.153L15.1751 9.08854ZM9.93099 9.08854H14.0996L13.0775 6.5H11.0671L9.93099 9.08854ZM8.69922 6.5C8.43939 6.5 8.18982 6.61267 8.01498 6.81185L6.06706 9.0306C6.05067 9.04927 6.03551 9.0689 6.02084 9.08854H8.83789L9.97396 6.5H8.69922Z" fill="var(--color-primary)" />
                                </svg>
                            </div>
                            <div className="text">
                                <p className="title">
                                    {`${trialDays > 0 ? getFutureDate(trialDays, lang) + ": " : ""}${t("Subscription starts")}`}
                                </p>
                                <p className="desc">{t("{{v1}} will be billed annually through Shopify.", planSel === 'Annual' ? `$${prePlanInfo.pre_year?.price}` : `$${prePlanInfo.pre_month?.price}`)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    // 弹窗内容
    const modalContent = Boolean(isModal) ? (
        <Modal
            open={open}
            onClose={handleCloseModal}
            size="large"
        >
            {mainInfo}
        </Modal>
    ) : mainInfo;

    return modalContent;
}

// utils/date.js
function getFutureDate(days, local = "en") {
    const lang_list = {
        "cs": "cs-CZ",
        "en": "en-US",
        "da": "da-DK",
        "es": "es-ES",
        "fr": "fr-FR",
        "de": "de-DE",
        "in": "hi-IN",
        "it": "it-IT",
        "nl": "nl-NL",
        "nb": "no-NO",
        "pl": "pl-PL",
        "pt": "pt-PT",
        "pt_BR": "pt-BR",
        "fi": "fi-FI",
        "sv": "sv-SE",
        "tr": "tr-TR",
        "th": "th-TH",
        "ja": "ja-JP",
        "ko": "ko-KR",
        "zh": "zh-CN",
        "zh_hant": "zh-TW",
    } // 语言列表
    const today = new Date();
    // 复制当前日期，避免修改原始对象
    const future = new Date(today);
    // 加上天数
    future.setDate(today.getDate() + days);
    // 格式化
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return future.toLocaleDateString(lang_list[local], options);
}

export default withRouter(UserTrialDicountModal);